/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Loader,
  Dimmer,
  Segment,
  Label,
  Icon,
  Popup,
  List,
  Pagination,
  Input,
  Modal,
  Button
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { autorun, reaction } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import $ from 'jquery';
import api from '../../api';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import Footer from '../Footer/Footer';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import WithRouter from '../Extensions/WithRouter';
import CreateUserIssueModal from '../Jira/CreateUserIssueModal';
import JiraLogo from '../../images/icons/jira/jira_origin.svg';
import RenderProjectTree from '../Extensions/RenderProjectTree';

class PolicyDetail extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.smallBody = null;
    this.policyList = React.createRef();
    this.state = {
      isOpenMCI: false,
      idReport: this.props.params.idReport,
      pageSize: this.props.state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: this.props.state.user.view_mode,
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      hasMore: false,
      policyList: [],
      activeIndex: [],
      moreInfoIndex: [],
      policyTreeData: [],
      popupIndex: '',
      sortValue: '9',
      isSort: false,
      searchKeyword: '',
      filter: [],
      popupStatus: {
        conditionPopup: false,
      },
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      currentPolicySettingId: '',
      currentRevision: '',
      totalCount: 0,
    };
  }

  componentDidMount() {
    const { state } = this.props;
    window.addEventListener('scroll', this.handleOnScroll);
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 140) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });
    document.addEventListener('mousedown', this.handleClickOutside);

    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tac', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    this.disposeUserReaction = autorun(() => {
      this.setState({
        viewMode: state.user.view_mode,
        pageSize: state.user.page_limit,
      });
    });

    this.disposePolicyListReaction = reaction(
      () => { return state.user.currentPrecisionLevel; },
      (currentPrecisionLevel) => {
        if (currentPrecisionLevel !== null && this.policyList) {
          this.getPolicyfileList();
        }
      },
      {
        fireImmediately: true
      }
    );
  }

  componentDidUpdate(prevProps) {
    const { params } = this.props;

    if (prevProps.params.idReport !== params.idReport) {
      this.setState(
        {
          idReport: params.idReport,
          policyList: [],
        },
        () => {
          this.getPolicyfileList();
        }
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.disposeUserReaction) {
      this.disposeUserReaction();
    }

    if (this.disposePolicyListReaction) {
      this.disposePolicyListReaction();
    }
  }

  handleActivePageChange = (e) => {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        policyList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getPolicyfileList(activePage, pageSize);
      });
    }
  };

  handleInputActivePageChange = (e, { value }) => {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  };

  handleMoreInfoOpen = (index) => {
    const { moreInfoIndex } = this.state;
    let newState;

    if (moreInfoIndex.indexOf(index) === -1) {
      newState = [...moreInfoIndex, index];
    } else {
      newState = moreInfoIndex;
    }

    this.setState({
      moreInfoIndex: newState,
      popupType: 'type_2',
    });
  };

  handleOtherPolicy = (index, ids) => {
    const { moreInfoIndex } = this.state;
    let newState;

    if (moreInfoIndex.indexOf(index) === -1) {
      newState = [...moreInfoIndex, index];
    } else {
      newState = moreInfoIndex;
    }

    this.setState(
      {
        moreInfoIndex: newState,
        popupType: 'type_0',
      },
      () => {
        this.getProjectTree(ids);
      }
    );
  };

  handleMoreInfoClose = (index) => {
    const { moreInfoIndex } = this.state;
    const newState = moreInfoIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      moreInfoIndex: newState,
      popupType: '',
    });
  };

  handleClickOutside = (event) => {
    const container = $('.card_detail_popup');
    if (container && container.has(event.target).length === 0) {
      if (this.state.moreInfoIndex.length !== 0 && this.state.popupType !== '') {
        this.setState({
          moreInfoIndex: '',
          popupType: '',
        });
        return true;
      }
      return false;
    }
  };

  handleOnScroll = () => {
    const {
      getPolicyfileList,
      state: {
        error, isLoading, hasMore, viewMode
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getPolicyfileList(this.state.currentPage + 1);
    }
  };

  handleChange = (value) => {
    this.setState(
      {
        searchKeyword: value,
        policyList: [],
        activeIndex: [],
      },
      () => {
        this.getPolicyfileList();
      }
    );
  };

  handleFilterData = (value) => {
    this.setState(
      {
        policyList: [],
        activeIndex: [],
        filter: value.filter,
      },
      () => {
        this.getPolicyfileList();
      }
    );
  };

  handlePopupOpen = (policySettingId) => {
    const status = {
      conditionPopup: true,
    };
    this.setState({
      popupStatus: status,
      popupIndex: policySettingId,
    });
  };

  handlePopupClose = () => {
    const status = {
      conditionPopup: false,
    };
    this.setState({
      popupStatus: status,
      popupIndex: '',
    });
  };

  handlePageSizeChange = (value) => {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        policyList: [],
        activeIndex: [],
      },
      () => {
        this.getPolicyfileList();
      }
    );
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      policyList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getPolicyfileList(activePage, pageSize);
    });
  };

  handleSearchChange = (value) => {
    this.setState({
      searchKeyword: value,
    });
  };

  handleMCIOpen = (id, rev) => {
    this.setState({
      isOpenMCI: true,
      currentPolicySettingId: id,
      currentRevision: rev,
    });
  };

  handleIssueCallback = () => {
    this.setState(
      {
        policyList: [],
        activeIndex: [],
        isOpenMCI: false,
      },
      () => {
        this.getPolicyfileList();
      }
    );
  };

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          policyList: [],
          activeIndex: [],
        },
        () => {
          this.getPolicyfileList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          policyList: [],
          activeIndex: [],
        },
        () => {
          this.getPolicyfileList();
        }
      );
    }
  };

  setPrecisionLevel = (value) => {
    const { state } = this.props;
    this.setState({
      policyList: [],
      activeIndex: [],
    }, () => {
      state.user.setPrecisionLevel(value);
    });
  };

  getPolicyfileList = (pageNo, limit) => {
    let text;
    let filterData;
    let precisionLevel;

    const {
      isSort, sortValue, policyList, pageSize
    } = this.state;
    const { state } = this.props;
    const userStore = { ...state.user };
    const page = pageNo || 1;
    let perPage = limit || pageSize;

    if (perPage === '') {
      perPage = userStore.page_limit || localStorage.getItem('page_limit');
    }

    if (this.props.state.user.currentPrecisionLevel) {
      precisionLevel = this.props.state.user.currentPrecisionLevel;
    } else {
      precisionLevel = null;
    }

    if (this.state.filter.length !== 0) {
      let i = 0;
      for (i; i < this.state.filter.length; i++) {
        if (i === 0) {
          filterData = this.state.filter[i];
        } else {
          filterData = `${filterData},${this.state.filter[i]}`;
        }
      }
      filterData = `${filterData}`;
    } else {
      filterData = '';
    }
    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'name';
      } else {
        text = 'name_r';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'revision_r';
      } else {
        text = 'revision';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'coverage_r';
      } else {
        text = 'coverage';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'category_r';
      } else {
        text = 'category';
      }
      break;
    case sortValue === '5':
      if (isSort) {
        text = 'condition_r';
      } else {
        text = 'condition';
      }
      break;
    default:
      text = 'detected';
      break;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getPolicyfileList(
            {
              search: this.state.searchKeyword,
              filter: filterData,
              page,
              limit: perPage,
              order: text,
              precision_level: precisionLevel,
            },
            this.state.idReport
          )
          .then((response) => {
            if (this.state.policyList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextPolicyList = response.response.map((item) => {
              return {
                uploadedFileId: item.uploaded_file_id,
                policySettingId: item.policy_setting_id,
                policyName: item.policy_name,
                revision: item.revision,
                coverage: item.coverage,
                category: item.category,
                condition: item.condition,
                conditionDetail: item.condition_detail,
                jiraIssue: item.jira_issue,
              };
            });

            this.setState({
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              totalPage: response.pagination.pages,
              totalCount: response.pagination.count,
              hasMore: response.pagination.next !== null,
              isLoading: false,
              policyList: [...policyList, ...nextPolicyList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoading: false,
            });
          });
      }
    );
  };

  getPolicyFileDetail = (policyId, revision) => {
    let precisionLevel;

    if (this.props.state.user.currentPrecisionLevel) {
      precisionLevel = this.props.state.user.currentPrecisionLevel;
    } else {
      precisionLevel = null;
    }

    this.setState({
      isDetailLoading: true,
      isVisible: `${policyId}_${revision}`,
    }, () => {
      api
        .getPolicyFileDetail(
          {
            policy_setting_id: policyId,
            revision,
            precision_level: precisionLevel,
          },
          this.props.params.idReport
        )
        .then((response) => {
          const { policyList } = this.state;
          const data = response.response;
          const updatedIndex = policyList.findIndex((item) => {
            return item.policySettingId === policyId && item.revision === revision;
          });

          const updatedData = Update(policyList[updatedIndex], {
            policyDetails: { $set: data },
          });
          const newData = Update(policyList, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
          this.setState({
            policyList: newData,
            isDetailLoading: false,
            isVisible: '',
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  getProjectTree = (ufid) => {
    const value = JSON.parse(`[${ufid}]`);
    const obj = {
      uploaded_file_ids: value,
    };
    api
      .getProjectTree(obj)
      .then((response) => {
        const data = response.response;
        this.setState({
          policyTreeData: data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 15) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 14 && tableEl.length > 15) || (i > 15 && (i - 14) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleRow = (e, index, policyId, revision) => {
    const { activeIndex } = this.state;

    let newState;

    if (e.target.classList.contains('jira') || e.target.classList.contains('jira_issue')) {
      return;
    }

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getPolicyFileDetail(policyId, revision);
      newState = [...activeIndex, index];
    }
    this.setState({ activeIndex: newState });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      policyList: [],
      activeIndex: [],
    }, () => {
      this.getPolicyfileList();
    });
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
      isOpenMCI: false,
    });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        policyList: [],
        activeIndex: [],
        filter: newState,
      },
      () => {
        this.getPolicyfileList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        policyList: [],
        activeIndex: [],
        filter: [],
      },
      () => {
        this.getPolicyfileList();
      }
    );
  };

  clearSearch = () => {
    this.setState(
      {
        searchKeyword: '',
        policyList: [],
        activeIndex: [],
      },
      () => {
        this.getPolicyfileList();
      }
    );
  };

  renderValue = () => {
    const { filter } = this.state;
    const { t } = this.props;

    const policyFilter = filter.filter((item) => {
      return item.indexOf('policy') > -1;
    });

    const coverageFilter = filter.filter((item) => {
      return item.indexOf('coverage') > -1;
    });

    const filterObj = {
      policy: policyFilter,
      coverage: coverageFilter,
    };

    return (
      <div>
        {filterObj.policy.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('settings.list.category')}</strong>
            </span>
            {filterObj.policy.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_cp') > -1 && t('list.title.component')}
                  {item.indexOf('_sc') > -1 && t('list.title.security')}
                  {item.indexOf('_lc') > -1 && t('list.title.license')}
                  {item.indexOf('_lt') > -1 && t('list.title.litigtor')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.coverage.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('settings.list.coverage')}</strong>
            </span>
            {filterObj.policy.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_c') > -1 && t('contents_header.menu.company')}
                  {item.indexOf('_p') > -1 && t('contents_header.menu.project')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filter.length !== 0 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  };

  renderConditionValue = (data) => {
    const objKey = data.conditionDetail;
    const { t } = this.props;
    const { popupIndex, popupStatus } = this.state;
    if (data.category === 'component') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && popupIndex === data.policySettingId
            }
            onOpen={() => {
              return this.handlePopupOpen(data.policySettingId);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.component.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('link_header.components')}
                      (
                      {objKey.component.length}
                      )
                    </List.Header>
                    {
                      objKey.component.map((item) => {
                        return (
                          <List.List key={uuidv4()}>
                            <span style={{ fontWeight: '500', marginRight: '5px' }}>{item.component}</span>
                            {`${item.version_condition || ''} ${item.selected_version || ''}`}
                          </List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    } else if (data.category === 'security') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && popupIndex === data.policySettingId
            }
            onOpen={() => {
              return this.handlePopupOpen(data.policySettingId);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.severity.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('settings.list.security_risk_severity')}
                      (
                      {objKey.severity.length}
                      )
                    </List.Header>
                    {
                      objKey.severity.map((item) => {
                        return (
                          <List.List key={uuidv4()}>
                            {
                              item === 'critical' && 'Critical'
                            }
                            {
                              item === 'high' && 'High'
                            }
                            {
                              item === 'medium' && 'Medium'
                            }
                            {
                              item === 'low' && 'Low'
                            }
                          </List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
              {
                objKey.code.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('settings.list.securities')}
                      (
                      {objKey.code.length}
                      )
                    </List.Header>
                    {
                      objKey.code.map((item) => {
                        return (
                          <List.List key={uuidv4()}>{item}</List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    } else if (data.category === 'license') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && popupIndex === data.policySettingId
            }
            onOpen={() => {
              return this.handlePopupOpen(data.policySettingId);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.family.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('list.title.license_family')}
                      (
                      {objKey.family.length}
                      )
                    </List.Header>
                    {
                      objKey.family.map((item) => {
                        return (
                          <List.List key={uuidv4()}>
                            {
                              item === 'protective' && 'Protective'
                            }
                            {
                              item === 'permissive' && 'Permissive'
                            }
                            {
                              item === 'others' && 'Others'
                            }
                          </List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
              {
                objKey.name.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('project.menu.licenses')}
                      (
                      {objKey.name.length}
                      )
                    </List.Header>
                    {
                      objKey.name.map((item) => {
                        return (
                          <List.List key={uuidv4()}>{item}</List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    } else if (data.category === 'litigator') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && popupIndex === data.policySettingId
            }
            onOpen={() => {
              return this.handlePopupOpen(data.policySettingId);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.name.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('project.menu.litigator')}
                      (
                      {objKey.name.length}
                      )
                    </List.Header>
                    {
                      objKey.name.map((item) => {
                        return (
                          <List.List key={uuidv4()}>
                            {
                              item === 'mchardy' && 'McHardy'
                            }
                            {
                              item === 'sfc' && 'SFC'
                            }
                            {
                              item === 'patents' && 'Patent Module'
                            }
                          </List.List>
                        );
                      })
                    }
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    }
    return (
      <span className="number">
        {data.condition}
      </span>
    );
  };

  renderJiraIssueEle = (obj) => {
    const { t } = this.props;
    const data = obj.jiraIssue;

    if (data.url === '') {
      return (
        <Button
          className="jira"
          onClick={() => {
            return this.handleMCIOpen(
              obj.policySettingId,
              obj.revision
            );
          }}
        >
          <span className="icon-wrap">
            <img className="icon-jira" src={JiraLogo} alt="" />
          </span>
          {t('settings.list.create_issue')}
        </Button>
      );
    }
    return (
      <span className="jira_issue">
        <a
          href={data.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'underline' }}
          className="jira_issue"
        >
          {data.key}
        </a>
      </span>
    );

  };

  renderMoreInformation = (array, type) => {
    if (type === 'security') {
      return array.map((item, index) => {
        return index % 5 === 0 && (
          <tr
            key={uuidv4()}
          >
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index].more === 'critical',
                        },
                        {
                          orange: array[index].more === 'high',
                        },
                        {
                          cheese: array[index].more === 'medium',
                        },
                        {
                          yellow: array[index].more === 'low',
                        }
                      )}
                    >
                      {array[index].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index + 1].more === 'critical',
                        },
                        {
                          orange: array[index + 1].more === 'high',
                        },
                        {
                          cheese: array[index + 1].more === 'medium',
                        },
                        {
                          yellow: array[index + 1].more === 'low',
                        }
                      )}
                    >
                      {array[index + 1].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 2],
                },
              )}
            >
              {
                array[index + 2] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index + 2].more === 'critical',
                        },
                        {
                          orange: array[index + 2].more === 'high',
                        },
                        {
                          cheese: array[index + 2].more === 'medium',
                        },
                        {
                          yellow: array[index + 2].more === 'low',
                        }
                      )}
                    >
                      {array[index + 2].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 3],
                },
              )}
            >
              {
                array[index + 3] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index + 3].more === 'critical',
                        },
                        {
                          orange: array[index + 3].more === 'high',
                        },
                        {
                          cheese: array[index + 3].more === 'medium',
                        },
                        {
                          yellow: array[index + 3].more === 'low',
                        }
                      )}
                    >
                      {array[index + 3].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 4],
                },
              )}
            >
              {
                array[index + 4] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet',
                        {
                          red: array[index + 4].more === 'critical',
                        },
                        {
                          orange: array[index + 4].more === 'high',
                        },
                        {
                          cheese: array[index + 4].more === 'medium',
                        },
                        {
                          yellow: array[index + 4].more === 'low',
                        }
                      )}
                    >
                      {array[index + 4].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
          </tr>
        );
      });
    }
    if (type === 'component') {
      return array.map((item, index) => {
        return index % 2 === 0 && (
          <tr
            key={uuidv4()}
          >
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  array[index].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  array[index].more
                ) : null
              }
            </td>
            <td className="tac border-none">
              &nbsp;
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  array[index + 1].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  array[index + 1].more
                ) : null
              }
            </td>
          </tr>
        );
      });
    }

    if (type === 'license') {
      return array.map((item, index) => {
        return index % 5 === 0 && (
          <tr
            key={uuidv4()}
          >
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index + 1].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 2],
                },
              )}
            >
              {
                array[index + 2] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index + 2].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 3],
                },
              )}
            >
              {
                array[index + 3] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index + 3].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 4],
                },
              )}
            >
              {
                array[index + 4] ? (
                  <div className="value_wrap">
                    <div
                      className={cx(
                        'bullet bullet_disk',
                        {
                          red: array[index].more === 'protective',
                        },
                        {
                          orange: array[index].more === 'permissive',
                        },
                        {
                          yellow: array[index].more === 'others',
                        },
                      )}
                    >
                      {array[index + 4].name}
                    </div>
                  </div>
                ) : null
              }
            </td>
          </tr>
        );
      });
    }

    if (type === 'litigator') {
      return array.map((item, index) => {
        return index % 5 === 0 && (
          <tr
            key={uuidv4()}
          >
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index],
                },
              )}
            >
              {
                array[index] ? (
                  array[index].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 1],
                },
              )}
            >
              {
                array[index + 1] ? (
                  array[index + 1].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 2],
                },
              )}
            >
              {
                array[index + 2] ? (
                  array[index + 2].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 3],
                },
              )}
            >
              {
                array[index + 3] ? (
                  array[index + 3].name
                ) : null
              }
            </td>
            <td
              className={cx(
                'tac',
                {
                  'border-none': !array[index + 4],
                },
              )}
            >
              {
                array[index + 4] ? (
                  array[index + 4].name
                ) : null
              }
            </td>
          </tr>
        );
      });
    }
    return null;
  };

  render() {
    const {
      error,
      hasMore,
      isLoading,
      policyList,
      activeIndex,
      filter,
      sortValue,
      isSort,
      moreInfoIndex,
      popupType,
      policyTreeData,
      isDetailLoading,
      isVisible,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      isOpenMCI,
      currentPolicySettingId,
      currentRevision,
      searchKeyword,
      totalCount,
    } = this.state;

    const {
      state, location, params, t, navigate
    } = this.props;

    const renderIfReady = (element, string) => {
      return (
        isDetailLoading && isVisible === string ? (
          <tr>
            <td className="border-none" colSpan="7">
              <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                <Loader active={isDetailLoading && isVisible === string} inline="centered" />
              </div>
            </td>
          </tr>
        ) : (
          element
        )
      );
    };

    return (
      <div
        className="result_file"
        ref={this.policyList}
      >
        {/** ContentsHeader Area */}
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          totalCount={totalCount}
          handlePrecisionLevel={this.setPrecisionLevel}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={this.state.isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          location={location}
          state={state}
          params={params}
          translate={t}
          navigate={navigate}
          searchKeyword={searchKeyword}
          handleSearchChange={this.handleSearchChange}
        />
        <div className="content">
          {/** filter Value Area */}
          {filter.length !== 0 ? (
            <div className="tag_list">{this.renderValue()}</div>
          ) : null}
          <div className="content_projects_List">
            <div className="wide_card_wrap">
              {/** table Header start */}
              <div className="table_header">
                <div className="table_header_inner">
                  <table className="wide_card_table wide_card_scope">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '13%', maxWidth: '120px' }} />
                      <col style={{ width: '9%' }} />
                      <col style={{ width: '9.1%', maxWidth: '84px' }} />
                      <col style={{ width: '13%' }} />
                      <col style={{ width: '' }} />
                      <col style={{ width: '20%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="checkbox_wrap tal">
                          <div className="checkbox" />
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="1" onClick={this.onChangeSorting}>
                            {t('settings.list.policy_name')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="1" onClick={this.onChangeSorting}>
                            {t('settings.list.revision')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="3" onClick={this.onChangeSorting}>
                            {t('settings.list.coverage')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="4" onClick={this.onChangeSorting}>
                            {t('settings.list.category')}
                            {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="5" onClick={this.onChangeSorting}>
                            {t('settings.list.detected_condition')}
                            {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/** Table Header End */}
              {
                policyList.map((item, index) => {
                  return (
                    <div
                      className={cx(
                        'wide_card_box',
                        {
                          expand: activeIndex.indexOf(index) >= 0,
                        },
                        {
                          card_detail_popup_show: moreInfoIndex.indexOf(index) >= 0,
                        },
                        {
                          type_2: popupType === 'type_2',
                        },
                        {
                          type_0: popupType === 'type_0',
                        },
                      )}
                      key={uuidv4()}
                    >
                      <table className="wide_card_table wide_card_item">
                        <colgroup>
                          <col style={{ width: '3.9%', maxWidth: '36px' }} />
                          <col style={{ width: '13%', maxWidth: '120px' }} />
                          <col style={{ width: '9%' }} />
                          <col style={{ width: '9.1%', maxWidth: '84px' }} />
                          <col style={{ width: '13%' }} />
                          <col style={{ width: '' }} />
                          <col style={{ width: '20%' }} />
                          <col style={{ width: '4.3%', maxWidth: '40px' }} />
                        </colgroup>
                        <tbody>
                          <tr
                            className="sum_line"
                            onClick={(e) => {
                              return this.toggleRow(e, index, item.policySettingId, item.revision);
                            }}
                          >
                            <td className="checkbox_wrap border-none tal">
                              <div className="checkbox" />
                            </td>
                            <td className="border-none tal">
                              {item.policyName}
                            </td>
                            <td className="tal">
                              rev_
                              {item.revision}
                            </td>
                            <td className="tac">
                              {item.coverage === 'company' && t('list.title.company')}
                              {item.coverage === 'project' && t('list.title.project')}
                            </td>

                            <td className="tac">
                              {item.category === 'component' && t('list.title.component')}
                              {item.category === 'security' && t('list.title.security')}
                              {item.category === 'license' && t('list.title.license')}
                              {item.category === 'litigator' && t('list.title.litigator')}
                            </td>
                            <td className="tal">{this.renderConditionValue(item)}</td>
                            <td className="tac jira">{this.renderJiraIssueEle(item)}</td>
                            <td className="border-none tal">
                              <a
                                className="expand_button"
                              >
                                <img src={expandBtn} alt="" />
                              </a>
                            </td>
                          </tr>
                          {
                            item.policyDetails && item.policyDetails.category === 'component' ? (
                              renderIfReady(
                                <tr className="extend_item">
                                  <td className="checkbox_wrap border-none tal">&nbsp;</td>
                                  <td className="border-none tal">&nbsp;</td>
                                  <td className="border-none tal">&nbsp;</td>
                                  <td className="border-none tac">&nbsp;</td>

                                  <td className="border-none tac">&nbsp;</td>
                                  <td className="border-none sum_td">
                                    <Scrollbars
                                      style={{
                                        height: '440px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                      }}
                                      renderTrackHorizontal={() => {
                                        return <div />;
                                      }}
                                      renderThumbHorizontal={() => {
                                        return <div />;
                                      }}
                                    >
                                      {
                                        item.policyDetails
                                            && item.policyDetails.detected.map((list) => {
                                              return (
                                                <table
                                                  className="wide_card_table wide_card_item"
                                                  key={uuidv4()}
                                                >
                                                  <colgroup>
                                                    <col style={{ width: '50%' }} />
                                                    <col style={{ width: '50%' }} />
                                                  </colgroup>
                                                  <tbody>
                                                    <tr>
                                                      <td
                                                        className="tal border-bottom"
                                                        style={{
                                                          paddingLeft: '7px',
                                                          overflow: 'hidden',
                                                          textOverflow: 'ellipsis',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        {list.name}
                                                      </td>
                                                      <td
                                                        className="tal border-bottom"
                                                        style={{
                                                          paddingLeft: '7px',
                                                          overflow: 'hidden',
                                                          textOverflow: 'ellipsis',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        {list.more}
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              );
                                            })
                                      }
                                    </Scrollbars>
                                  </td>
                                  <td className="border-none tac">&nbsp;</td>
                                  <td className="border-none tal">
                                    &nbsp;
                                  </td>
                                </tr>,
                                `${item.policySettingId}_${item.revision}`
                              )
                            ) : null
                          }
                          {
                            item.policyDetails && item.policyDetails.category === 'security' ? (
                              renderIfReady(
                                <tr className="extend_item">
                                  <td className="checkbox_wrap border-none tal">&nbsp;</td>
                                  <td className="border-none tal">&nbsp;</td>
                                  <td className="border-none tal">&nbsp;</td>
                                  <td className="border-none tac">&nbsp;</td>

                                  <td className="border-none tac">&nbsp;</td>
                                  <td className="border-none sum_td">
                                    <Scrollbars
                                      style={{
                                        height: '440px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                      }}
                                      renderTrackHorizontal={() => {
                                        return <div />;
                                      }}
                                      renderThumbHorizontal={() => {
                                        return <div />;
                                      }}
                                    >
                                      {
                                        item.policyDetails
                                            && item.policyDetails.detected.map((list) => {
                                              return (
                                                <table
                                                  className="wide_card_table wide_card_item"
                                                  key={uuidv4()}
                                                >
                                                  <tbody>
                                                    <tr>
                                                      <td
                                                        className="tal border-bottom"
                                                        style={{
                                                          paddingLeft: '7px',
                                                          overflow: 'hidden',
                                                          textOverflow: 'ellipsis',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        <div className="value_wrap">
                                                          {
                                                            list.more === 'critical'
                                                            && <div className="bullet red">{list.name}</div>
                                                          }
                                                          {
                                                            list.more === 'high'
                                                            && <div className="bullet orange">{list.name}</div>
                                                          }
                                                          {
                                                            list.more === 'medium'
                                                            && <div className="bullet cheese">{list.name}</div>
                                                          }
                                                          {
                                                            list.more === 'low'
                                                            && <div className="bullet yellow">{list.name}</div>
                                                          }
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              );
                                            })
                                      }
                                    </Scrollbars>
                                  </td>
                                  <td className="border-none tac">&nbsp;</td>
                                  <td className="border-none tal">
                                    &nbsp;
                                  </td>
                                </tr>,
                                `${item.policySettingId}_${item.revision}`
                              )
                            ) : null
                          }
                          {
                            item.policyDetails && item.policyDetails.category === 'license' ? (
                              renderIfReady(
                                <tr className="extend_item">
                                  <td className="checkbox_wrap border-none tal">&nbsp;</td>
                                  <td className="border-none tal">&nbsp;</td>
                                  <td className="border-none tal">&nbsp;</td>
                                  <td className="border-none tac">&nbsp;</td>

                                  <td className="border-none tac">&nbsp;</td>
                                  <td className="border-none sum_td">
                                    <Scrollbars
                                      style={{
                                        height: '440px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                      }}
                                      renderTrackHorizontal={() => {
                                        return <div />;
                                      }}
                                      renderThumbHorizontal={() => {
                                        return <div />;
                                      }}
                                    >
                                      {
                                        item.policyDetails
                                            && item.policyDetails.detected.map((list) => {
                                              return (
                                                <table
                                                  className="wide_card_table wide_card_item"
                                                  key={uuidv4()}
                                                >
                                                  <tbody>
                                                    <tr>
                                                      <td
                                                        className="tal border-bottom"
                                                        style={{
                                                          paddingLeft: '7px',
                                                          overflow: 'hidden',
                                                          textOverflow: 'ellipsis',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        <div className="value_wrap">
                                                          {
                                                            list.more === 'protective'
                                                            && <div className="bullet bullet_disk red">{list.name}</div>
                                                          }
                                                          {
                                                            list.more === 'permissive'
                                                            && <div className="bullet bullet_disk orange">{list.name}</div>
                                                          }
                                                          {
                                                            list.more === 'others'
                                                            && <div className="bullet bullet_disk yellow">{list.name}</div>
                                                          }
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              );
                                            })
                                      }
                                    </Scrollbars>
                                  </td>
                                  <td className="border-none tac">&nbsp;</td>
                                  <td className="border-none tal">
                                    &nbsp;
                                  </td>
                                </tr>,
                                `${item.policySettingId}_${item.revision}`
                              )
                            ) : null
                          }
                          {
                            item.policyDetails && item.policyDetails.category === 'litigator' ? (
                              renderIfReady(
                                <tr className="extend_item">
                                  <td className="checkbox_wrap border-none tal">&nbsp;</td>
                                  <td className="border-none tal">&nbsp;</td>
                                  <td className="border-none tal">&nbsp;</td>
                                  <td className="border-none tac">&nbsp;</td>

                                  <td className="border-none tac">&nbsp;</td>
                                  <td className="border-none sum_td">
                                    <Scrollbars
                                      style={{
                                        height: '440px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                      }}
                                      renderTrackHorizontal={() => {
                                        return <div />;
                                      }}
                                      renderThumbHorizontal={() => {
                                        return <div />;
                                      }}
                                    >
                                      {
                                        item.policyDetails
                                            && item.policyDetails.detected.map((list) => {
                                              return (
                                                <table
                                                  className="wide_card_table wide_card_item"
                                                  key={uuidv4()}
                                                >
                                                  <tbody>
                                                    <tr>
                                                      <td
                                                        className="tal border-bottom"
                                                        style={{
                                                          paddingLeft: '7px',
                                                          overflow: 'hidden',
                                                          textOverflow: 'ellipsis',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        {list.name}
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              );
                                            })
                                      }
                                    </Scrollbars>
                                  </td>
                                  <td className="border-none tac">&nbsp;</td>
                                  <td className="border-none tal">
                                    &nbsp;
                                  </td>
                                </tr>,
                                `${item.policySettingId}_${item.revision}`
                              )
                            ) : null
                          }
                        </tbody>
                      </table>
                      {
                        item.policyDetails ? (
                          <div className="wide_card_detail">
                            <div className="wide_card_detail_top type_description">
                              <p className="description">{t('list.title.all_condition')}</p>
                              <p className="version_text">{item.policyDetails.all_condition}</p>
                              <p className="description">{t('list.title.detected_condition')}</p>
                              <p className="version_text">{item.policyDetails.detected_condition}</p>
                              <p className="foo">{t('list.title.description')}</p>
                              <p className="version_text">
                                {item.policyDetails.description}
                              </p>
                            </div>
                            <div className="wide_card_detail_bottom">
                              {
                                item.policyDetails.more_information.length !== 0 ? (
                                  <a
                                    className={cx('card_detail_popup_show', {
                                      active: moreInfoIndex.indexOf(index) >= 0 && popupType === 'type_2',
                                    })}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      return this.handleMoreInfoOpen(index);
                                    }}
                                  >
                                    {t('list.title.more_information')}
                                  </a>
                                ) : null
                              }
                              <a
                                className={cx('card_detail_popup_show', {
                                  active: moreInfoIndex.indexOf(index) >= 0 && popupType === 'type_0',
                                })}
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  return this.handleOtherPolicy(
                                    index,
                                    item.policyDetails.uploaded_file_ids
                                  );
                                }}
                              >
                                {t('list.title.other_files_policy')}
                              </a>
                            </div>
                          </div>
                        ) : null
                      }
                      {
                        popupType === 'type_2'
                      && (
                        <div className="card_detail_popup card_detail_popup_3">
                          <div className="popup_box">
                            <h3 className="popup_header">
                              {t('list.title.more_information')}
                              <a
                                className="card_detail_popup_hide"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  return this.handleMoreInfoClose(index);
                                }}
                              >
                                <img src={closeBtn} alt="" />
                              </a>
                            </h3>
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <table className="wide_card_table information wide_card_item">
                                <colgroup>
                                  <col style={{ width: '17%' }} />
                                  <col style={{ width: '17%' }} />
                                  <col style={{ width: '17%' }} />
                                  <col style={{ width: '17%' }} />
                                  <col style={{ width: '' }} />
                                </colgroup>
                                <tbody>
                                  {
                                    item.policyDetails && item.policyDetails.category === 'component' ? (
                                      this.renderMoreInformation(item.policyDetails.more_information, 'component')
                                    ) : null
                                  }
                                  {
                                    item.policyDetails && item.policyDetails.category === 'security' ? (
                                      this.renderMoreInformation(item.policyDetails.more_information, 'security')
                                    ) : null
                                  }
                                  {
                                    item.policyDetails && item.policyDetails.category === 'license' ? (
                                      this.renderMoreInformation(item.policyDetails.more_information, 'license')
                                    ) : null
                                  }
                                  {
                                    item.policyDetails && item.policyDetails.category === 'litigator' ? (
                                      this.renderMoreInformation(item.policyDetails.more_information, 'litigator')
                                    ) : null
                                  }
                                </tbody>
                              </table>
                            </Scrollbars>
                          </div>
                        </div>
                      )
                      }
                      {policyTreeData.length !== 0 && popupType === 'type_0' && (
                        <div className="card_detail_popup card_detail_popup_1">
                          <div className="popup_box">
                            <h3 className="popup_header">
                              <a
                                className="card_detail_popup_hide"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  return this.handleMoreInfoClose(index);
                                }}
                              >
                                <img src={closeBtn} alt="" />
                              </a>
                            </h3>
                            <div className="popup_content">
                              <Scrollbars
                                renderTrackHorizontal={() => {
                                  return <div />;
                                }}
                                renderThumbHorizontal={() => {
                                  return <div />;
                                }}
                              >
                                <RenderProjectTree
                                  treeData={policyTreeData}
                                  translate={t}
                                  tableType={false}
                                  state={state}
                                />
                              </Scrollbars>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })
              }
              {error && <div className="error_log">{error}</div>}
              {isLoading && (
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="medium" style={{ lineHeight: '15px' }}>{t('modal.message.loading')}</Loader>
                  </Dimmer>
                </Segment>
              )}
              {
                viewMode === 'list' && policyList.length !== 0
                && (
                  <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      //size="mini"
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }

              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <Modal open={this.state.isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <CreateUserIssueModal
          isOpenMCI={isOpenMCI}
          idReport={params.idReport}
          settingId={currentPolicySettingId}
          revision={currentRevision}
          precisionLevel={state.user.currentPrecisionLevel}
          closeModal={this.closeModal}
          completeCallback={this.handleIssueCallback}
          translate={t}
          location={location}
        />
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(PolicyDetail))));
